import Alert from '@jbhi-fi/lanyard-ui/components/Alert';
import { Props as AlertProps } from '@jbhi-fi/lanyard-ui/components/Alert/Alert';
import React from 'react';
import { styles } from './ContentAlert.css';

export const ContentAlert = (props: AlertProps) => {
  return <Alert noMargin={true} {...props} classes={styles.alert} />;
};
